<template>
  <div class="grid-item-wrapper">
    <div class="asset-item" @click="itemChange(grid)" @mouseenter="onItemMouseEnter" @mouseleave="onItemMouseLeave">
      <!-- 显示视频、图片 slot -->
      <slot></slot>

      <div class="bg-blur" v-if="grid.preview_url" :style="{ backgroundImage: `url(${grid.preview_url})` }"></div>

      <slot name="action-btn"></slot>

      <div class="asset-item-state" :class="{ active: $parent.valueIds.includes(grid.id) }">
        <div class="title">
          <div class="title-text" :title="grid.name">
            <span>{{ grid.name }}</span>
            <span style="color: red" v-if="grid.ruleId">&emsp;素材管控：{{ grid.ruleId }}</span>
          </div>
          <div class="title-info">
            <span v-if="grid.duration">{{ grid.duration }}s</span>
            <span>&ensp;&ensp;{{ grid.size | fileSize }}</span>
          </div>
        </div>
        <!-- 素材管控时不显示 -->
        <span v-if="!grid.ruleId" class="check-state el-icon-success">选择</span>
      </div>

      <div style="position: absolute; z-index: 10; bottom: 0; left: 0; color: #fff">
        <slot name="analysis-tag"></slot>
      </div>
      <div class="image-info">
        <el-tag v-if="grid.width" type="info">{{ grid.width }}&times;{{ grid.height }}</el-tag>
        <el-tag v-if="grid.created_time" type="info">
          <span>{{ grid.created_time }}</span>
        </el-tag>
      </div>
    </div>
    <div class="grid-bottom">
      <MaterialMediaStates :info="grid" :show-rejection="false"></MaterialMediaStates>
    </div>
  </div>
</template>
<script>
import MaterialMediaStates from '@/views/material/library/components/material-media-states.vue'
export default {
  props: {
    grid: {
      type: Object
    }
  },
  components: { MaterialMediaStates },
  inject: ['itemChange'],
  filters: {
    fileSize(size) {
      if (typeof size !== 'number') return ''
      if (size > 104857) size = (size / 1048576).toFixed(2) + 'M'
      else if (size > 1024) size = (size / 1024).toFixed(2) + 'K'
      return size
    }
  },
  methods: {
    /**
     * @description: 显示、隐藏video audio controls
     * @param {*} e 鼠标事件
     */
    onItemMouseEnter(e) {
      const videoEle = e.target.querySelector('video')
      const audioEle = e.target.querySelector('audio')
      videoEle?.setAttribute('controls', true)
      audioEle?.setAttribute('controls', true)
    },
    onItemMouseLeave(e) {
      const videoEle = e.target.querySelector('video')
      const audioEle = e.target.querySelector('audio')
      videoEle?.removeAttribute('controls', false)
      audioEle?.removeAttribute('controls', false)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~common/styles/element-ui/variables.scss';
@mixin info-tag {
  color: #626262;
  line-height: 16px;
  height: 16px;
  background-color: rgb(213, 213, 213, 0.85);
}
.grid-item-wrapper {
  border: 1px solid #eee;
  ::v-deep .grid-bottom {
    .image-states {
      margin-top: 0;
      padding: 4px;
    }
  }

  .image-info {
    width: 100%;
    padding: 0 5px;
    position: absolute;
    left: 0;
    bottom: 5px;
    z-index: 12;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .el-tag {
      @include info-tag;
    }
  }
}
.asset-item {
  border-radius: 2px;
  overflow: hidden;
  background: #888;
  // height: 100%;
  text-align: center;
  position: relative;

  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  height: 160px;

  video {
    width: 100%;
  }
  video,
  img {
    position: relative;
    z-index: 5;
    // 纵图
    &.vertical {
      height: 100%;
    }
    // 横图
    &.horizontal {
      width: 100%;
    }
  }

  .audio-player {
    position: absolute;
    left: 0;
    bottom: 4px;
    height: 40px;
    width: 100%;
    z-index: 2;
  }

  .bg-blur {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    filter: blur(10px);
  }
  &-state {
    cursor: pointer;
    width: 100%;
    height: 42px;
    background: rgba(0, 0, 0, 0.6);
    position: absolute;
    left: 0;
    z-index: 6;
    top: 0;
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #fff;
    font-size: 12px;
    .title {
      text-align: left;
      flex-basis: 80%;
      overflow: hidden;
      &-text {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-weight: 700;
      }
      &-info {
        color: #bcbcbc;
      }
    }
    .check-state {
      flex: 1;
      flex-basis: 18%;
      text-align: right;
      font-size: 12px;
      font-weight: 700;
    }
    &.active {
      .check-state {
        color: $green;
      }
    }
  }

  // .image-upload-time {
  //   background: rgba(255, 255, 255, 0.6);
  //   padding: 2px;
  //   font-size: 12px;
  //   border-radius: 2px;
  //   color: white;
  // }
}
</style>
